import Vue from "vue";
import VueRouter from "vue-router";
import index from "../components/index.vue";
import gamelist from "../components/gamelist.vue";
import game from "../components/game.vue";
import goodsdetail from "../components/goodsdetail.vue";
import business from "../components/business.vue";
import sell from "../components/sell.vue";
import about from "../components/about.vue";
import down from "../components/down.vue";
import zuhaogamelist from "../components/zuhaogamelist.vue";
import login from "../components/login.vue";
import user from "../components/user.vue";
//重复点击路由报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
var seo_title = '红六账号服务网_QQ飞车账号交易_红六游戏服务网 - 红六账号服务网_QQ飞车账号交易_红六游戏服务网';
var seo_keywords = '红六,QQ飞车账号,剑灵账号,dnf账号，红六账号服务网,红六游戏';
var seo_description = '红六游戏账号交易服务网，专业的QQ飞车游戏账号、NDF地下城与勇士账号等游戏账号交易平台，游戏账号交易服务，选红六账号服务网。';
const routes = [{
		path: "/gamelist",
		name: "gamelist",
		component: gamelist,
		meta: {
			title: "游戏列表-" + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/zuhao",
		name: "zuhao",
		component: zuhaogamelist,
		meta: {
			title: "游戏租号-" + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/game",
		name: "game",
		component: game,
		meta: {
			title: seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/",
		name: "index",
		component: index,
		meta: {
			title: seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/goodsdetail",
		name: "goodsdetail",
		component: goodsdetail,
		meta: {
			title: '账号详情-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: '/a/:id',
		component: goodsdetail,
		name: "goodsdetail2",
		meta: {
			title: '账号详情-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/business",
		name: "business",
		component: business,
		meta: {
			title: '业务介绍-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/sell",
		name: "sell",
		component: sell,
		meta: {
			title: '账号估价-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/about",
		name: "about",
		component: about,
		meta: {
			title: '账号估价-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/down",
		name: "down",
		component: down,
		meta: {
			title: 'APP下载-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		},
	},
	{
		path: "/login",
		name: "login",
		component: login,
		meta: {
			title: '登录-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/user",
		name: "user",
		component: user,
		meta: {
			title: '个人中心-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
];

const router = new VueRouter({
	mode: "history",
	routes,
});

router.beforeEach((to, form, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
		document.keywords = to.meta.keywords
		document.description = to.meta.description
	}

	var logined = Boolean(localStorage.getItem('usertoken'))

	if (!logined) {

		if (to.meta.auth) {
			next('/login');
		} else {
			next();
		}

	} else {
		next();
	}

});

export default router;